import { render } from "./SpacePeopleComponent.vue?vue&type=template&id=348b931a&scoped=true&ts=true"
import script from "./SpacePeopleComponent.vue?vue&type=script&lang=ts"
export * from "./SpacePeopleComponent.vue?vue&type=script&lang=ts"

import "./SpacePeopleComponent.vue?vue&type=style&index=0&id=348b931a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348b931a"]])

export default __exports__